module.exports = __webpack_public_path__ + "static/media/bottomletterbar.e96dc44d.svg";